export function useAnchorId(data) {
  return computed(() => {
    const navTitle = data.value?.content?.nav_title || data.value?.content?.section_title;
    return navTitle ? navTitle.toLowerCase().replace(/\s+/g, '-') : null;
  });
}
